/**
 * Classification enum for {@link Layout}
 */
export enum LayoutEnum {
  MOBILE_MEDIA_WIDTH = 992
}
